import { Container } from 'src/components/common/Container'
import styled, { css } from 'styled-components'
import { PurchaseHistoryDetailPageProps } from 'src/pages/PurchaseHistoryPage/PurchaseHistoryDetailPage/index'
import { PurchaseHistoryDetailSpace } from 'src/types/api'
import { Typography } from 'src/components/common/Typography'
import {
  Noto_body1_b16,
  Noto_body1_m16,
  Noto_body1_r16,
  Noto_heading3_b20,
} from 'src/styles/fonts/NotoSansKrFonts'
import React from 'react'
import { Roboto_num2_b16, Roboto_num3_r14 } from 'src/styles/fonts/RobotoFonts'
import Button, { ButtonOption1 } from 'src/components/common/Button'
import { Icon } from 'src/assets/svg/Icon'
import { Divider, SmallDivider } from 'src/components/common/Divider'
import { CouponDetailCard } from 'src/components/common/CouponDetailCardItems'
import Skeleton from 'react-loading-skeleton'
import PurchaseHistoryDetailUnderLineTab from 'src/pages/PurchaseHistoryPage/PurchaseHistoryDetailPage/_components/PurchaseHistoryDetailUnderLineTab'
import useHtml2CanvasDown from 'src/hooks/useHtml2CanvasDown.hook'
import CouponCircleImage from 'src/components/common/CouponCircleImage'
import RenderIf from 'src/components/common/RenderIf'
import { useToast } from 'src/provider/ToastContextProvider'
import { useChannel } from 'src/provider/ChannelContextProvider'
import { getBrandAndCouponName } from 'src/utils'
import { ellip } from 'src/styles/mixin'
import { Barcode } from 'src/components/common/Barcode'
import DownloadCouponLayout from 'src/pages/DownloadCouponPage/_components/DownloadCouponLayout'

// 상시할인 -> 추가구매
// 취소가능 -> 구매취소
// 사용가능 -> 선물하기
// 사용가능 혹은 사용완료 -> 저장버튼
//
// ↓↓ 나올수 있는 경우 ↓↓
// 상시, 사용가능 [추가구매 | 선물하기 | 저장]
// 상시, 사용완료 [추가구매 | 저장]
// 상시, 그외 [추가구매]
//
// 핫딜, 사용가능 [선물하기 | 저장]
// 핫딜, 사용완료 [저장]
// 핫딜, 그외 []
//
// 취소가능 [구매취소]

const PurchaseHistoryDetailPageView = (props: PurchaseHistoryDetailPageProps) => {
  const {
    purchaseHistoryDetailData,
    isAlwaysDcCoupon,
    isUseAble,
    isUseComplete,
    purchaseHistoryDetailDataList,
    addPurchaseCouponHandler,
    cancelPurchaseCouponHandler,
    giftCouponHandler,
    barcodeDeemItem,
    isCancelAble,
    isShowBarcode,
    showBarcodeHandler,
  } = props
  const {
    Barcode: barcode,
    CouponName,
    CouponImage,
  } = purchaseHistoryDetailData as PurchaseHistoryDetailSpace.Response

  const { handleDownloadClick, componentRef } = useHtml2CanvasDown()
  const { openToast } = useToast()
  const { web } = useChannel()

  const handleImgDownLoad = () =>
    handleDownloadClick(() => {
      web && openToast({ contents: '이미지 저장 완료' })
    })

  return (
    <S.PurchaseHistory.Container $option="flex_column">
      <CouponDetailCard.Bg>
        <CouponDetailCard.Container $barcode={true}>
          <CouponDetailCard.Top>
            <CouponCircleImage src={CouponImage} />
            <S.PurchaseHistory.BrandName as={!!CouponName ? 'span' : Skeleton}>
              {getBrandAndCouponName(CouponName).brandName}
            </S.PurchaseHistory.BrandName>
            <S.PurchaseHistory.CouponName as={!!CouponName ? 'span' : Skeleton}>
              {getBrandAndCouponName(CouponName).couponName}
            </S.PurchaseHistory.CouponName>
          </CouponDetailCard.Top>
          <CouponDetailCard.Bottom>
            {/*사용 불가능한 쿠폰*/}
            <RenderIf when={!isUseAble && !isShowBarcode}>
              <Container
                $option="flex_column"
                $style={S.PurchaseHistory.BarcodeDeem}
                onClick={showBarcodeHandler}
              >
                <S.PurchaseHistory.BarcodeStatusIcon src={barcodeDeemItem?.imgSrc} alt="deem" />
                <Container $option="flex_column" $row_gap="4px">
                  <Typography $fontStyle={Noto_heading3_b20}>{barcodeDeemItem?.text}</Typography>
                  <RenderIf when={isUseComplete}>
                    <Typography $fontStyle={Roboto_num3_r14}>(클릭하여 바코드 확인)</Typography>
                  </RenderIf>
                </Container>
              </Container>
            </RenderIf>
            <RenderIf when={!!barcode}>
              <Barcode.Image value={`${barcode}`} barcode_height={74} />
              <Barcode.Text value={`${barcode}`} fontStyle={Roboto_num2_b16} />
            </RenderIf>
            <RenderIf when={!barcode}>
              <Skeleton height={100} />
            </RenderIf>
          </CouponDetailCard.Bottom>
        </CouponDetailCard.Container>
      </CouponDetailCard.Bg>
      <RenderIf when={isAlwaysDcCoupon || isUseAble || isUseComplete}>
        <S.PurchaseHistory.TopButtonWrap
          $color={!isUseAble && !isUseComplete ? 'var(--brand-10)' : 'var(--black-4)'}
        >
          <RenderIf when={isAlwaysDcCoupon}>
            <S.PurchaseHistory.TextButton onClick={addPurchaseCouponHandler} disabled={!barcode}>
              <Typography $fontStyle={Noto_body1_b16} $color="var(--brand-50)">
                추가구매
              </Typography>
            </S.PurchaseHistory.TextButton>
          </RenderIf>
          <RenderIf when={isUseAble}>
            <S.PurchaseHistory.TextButton onClick={giftCouponHandler}>
              <Typography $fontStyle={Noto_body1_b16} $color="var(--black-90)">
                선물하기
              </Typography>
            </S.PurchaseHistory.TextButton>
          </RenderIf>
          <RenderIf when={isUseAble || isUseComplete}>
            <S.PurchaseHistory.TextButton onClick={handleImgDownLoad} disabled={!barcode}>
              <Typography $fontStyle={Noto_body1_r16} $color="var(--black-60)">
                저장
              </Typography>
              <Icon.DownLoad />
            </S.PurchaseHistory.TextButton>
          </RenderIf>
        </S.PurchaseHistory.TopButtonWrap>
      </RenderIf>
      <CouponDetailCard.DetailInfoList>
        {purchaseHistoryDetailDataList?.map(
          (ele: { text: string; value: string } | null, index: number) => (
            <RenderIf when={!!ele?.text} key={index}>
              <CouponDetailCard.DetailInfoLine
                key={index}
                $disabled={!ele}
                as={ele?.value !== '' || !!ele?.value ? 'div' : Skeleton}
              >
                <CouponDetailCard.DetailTitle>{ele?.text}</CouponDetailCard.DetailTitle>
                <CouponDetailCard.DetailDesc>{ele?.value}</CouponDetailCard.DetailDesc>
              </CouponDetailCard.DetailInfoLine>
            </RenderIf>
          ),
        )}
      </CouponDetailCard.DetailInfoList>
      <SmallDivider />
      <RenderIf when={isCancelAble}>
        <S.PurchaseHistory.MiddleButtonWrap $option="flex_row">
          <Button
            option={ButtonOption1('default')}
            onClickFn={cancelPurchaseCouponHandler}
            disabled={!barcode}
          >
            구매취소
          </Button>
        </S.PurchaseHistory.MiddleButtonWrap>
      </RenderIf>
      <Divider />
      <PurchaseHistoryDetailUnderLineTab {...props} />
      {/*다운로드*/}
      <RenderIf when={isUseAble || isUseComplete}>
        <DownloadCouponLayout
          couponDetailData={purchaseHistoryDetailData!}
          componentRef={componentRef}
          barcode={purchaseHistoryDetailData?.Barcode!}
        />
      </RenderIf>
    </S.PurchaseHistory.Container>
  )
}
export default PurchaseHistoryDetailPageView

const S = {
  PurchaseHistory: {
    Container: styled(Container)`
      position: relative;
      background-color: var(--white);
    `,
    TopButtonWrap: styled(Container)<{ $color: string }>`
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      padding: 17px 12px;
      background-color: ${({ $color }) => $color};
    `,
    MiddleButtonWrap: styled(Container)`
      padding: 20px;
      gap: 10px;
    `,
    TextButton: styled.button`
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 3px;

      &:not(:last-child) {
        border-right: 1px solid var(--black-30);
      }
    `,
    BrandName: styled(Typography)`
      margin: 14px 0 6px 0;
      ${Noto_body1_m16};
      color: var(--black-50);
    `,
    CouponName: styled(Typography)`
      ${Noto_heading3_b20};
      color: var(--black-90);
      ${ellip('line2')};
      text-align: center;
    `,
    ValidDay: styled(Typography)`
      ${Noto_body1_m16};
    `,
    RegularPrice: styled(Typography)`
      ${Noto_body1_m16};
    `,
    BarcodeDeem: css`
      width: 284px;
      height: 122px;
      backdrop-filter: blur(2px);
      background: rgba(255, 255, 255, 0.9);
      margin-top: -16px;
      position: absolute;
      z-index: 1;
      left: 50%;
      transform: translate(-50%, 0);
      gap: 10px;
      align-items: center;
      justify-content: center;
    `,
    BarcodeStatusIcon: styled.img`
      display: flex;
      width: 35px;
      height: 34px;
      margin: 0 auto;
    `,
  },
}
